<template>
  <div class="heliar-nav">
    <div class="heliar-nav--return">
      <router-link :to="{ name: 'home' }"
        ><span class="icon icon-chevron-left"> </span>Voltar para a página inicial</router-link
      >
    </div>
    <h3 class="heliar-nav--title">Entrega Heliar Express</h3>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.heliar-nav {
  &--return {
    font-size: 16px;
    color: $cinza-escuro;
    margin-bottom: 20px;
    .icon {
      line-height: 0;
      font-size: 12px;
      display: inline-block;
      margin-right: 7px;
    }
    a {
      color: inherit;
      &:hover {
        color: inherit;
        text-decoration: none;
      }
    }
  }
  &--title {
    font-weight: 900;
    font-size: 30px;
    text-transform: uppercase;
    font-style: italic;
    margin-bottom: 48px;
  }
}
@media (max-width: 991px) {
  .heliar-nav {
    &--return {
      display: none;
    }
    &--title {
      text-align: center;
      font-size: 44px;
      margin-bottom: 54px;
    }
  }
}
@media (max-width: 767px) {
  .heliar-nav {
    &--title {
      font-size: 40px;
      margin-bottom: 50px;
    }
  }
}
@media (max-width: 575px) {
  .heliar-nav {
    &--title {
      font-size: 30px;
      margin-bottom: 40px;
    }
  }
}
</style>
